export default "__VITE_ASSET__Bo4110YE__"